import { withGyymAuthRedirect } from './withGyymAuthRedirect'

export const withGyymUnauthGuard = (destination: string, permanent = false) => {
  return withGyymAuthRedirect(
    destination,
    (_, { authState }) => !!authState.isLoggedIn,
    permanent,
  )
}
